import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import {
  UPDATE_STOCK_INPUT,
  UPDATE_SUMMARY_INPUT,
  SET_TICKER_INFO,
  TOGGLE_TICKER_STRIKETHROUGH,
  NOTI_TIMEOUT,
  BASE_URL,
  UPDATE_SPX_QUARTERLY
} from './types';

export function updateDbStockInput({ symbol, name, value, activePortfolioId }) {
  const url = `${BASE_URL()}/api/updatestockinput`;  
  const request = axios.patch(url, { symbol, name, value, activePortfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then(() => {}).catch(() => {});
  }
}

export function updateDbSectorInput({ symbol, name, value, activePortfolioId }) {
  const url = `${BASE_URL()}/api/updatesectorinput`;
  const request = axios.patch(url, { symbol, name, value, activePortfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then(() => {}).catch(() => {});
  }
}

export function updateDbQuarterSummary({ name, value, activePortfolioId }) {
  const url = `${BASE_URL()}/api/updatequartersummary`;
  const request = axios.patch(url, { name, value, activePortfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then(() => {}).catch(() => {});
  }
}

export function updateStockInput(payload) {
  return {
    type: UPDATE_STOCK_INPUT,
    payload: payload
  };
}

export function updateSummaryInput(payload) {
  return {
    type: UPDATE_SUMMARY_INPUT,
    payload: payload
  };
}

export function changeCurrentQuarter({ newQuarter, portfolioId }) {
  const url = `${BASE_URL()}/api/changecurrentquarter`;
  const request = axios.post(url, { newQuarter, portfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then((response) => {
      dispatch({ type: SET_TICKER_INFO, payload: response });
    }).catch(() => {
      NotificationManager.error(`There was an error changing the current quarter. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  }
}

export function toggleTickerstrikethrough({ symbol, flag, portfolioId }) {
  const url = `${BASE_URL()}/api/toggletickerstrikethrough`;
  const request = axios.post(url, { symbol, flag, portfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then((response) => {
      dispatch({ type: TOGGLE_TICKER_STRIKETHROUGH, payload: { symbol, flag }});
    }).catch(() => {
      NotificationManager.error(`There was an error toggling the strikethrough. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  }
}

export function updateSPXQuarterly({ symbol, value, activePortfolioId }) {
  const url = `${BASE_URL()}/api/updatebenchmarkinput`;
  const request = axios.patch(url, { symbol, value, activePortfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then((response) => {
      dispatch({ type: UPDATE_SPX_QUARTERLY, payload: { symbol, value } });
    }).catch(() => {

    });
  }
}